<nav class="text-left">
  <button
    type="button"
    class="mb-6 flex items-center text-left text-small font-semibold text-steel-20 transition-all"
    [class.mb-0!]="collapsed()"
    (click)="toggle()"
  >
    <span>
      {{ 'footer.location-links.' + verticalType + '.' + (isIndividual ? 'agents' : 'agencies') | lowercase | transloco }}
    </span>
    <span class="sr-only">{{ 'footer.location-links.view.' + (collapsed() ? 'more' : 'less') | transloco }}</span>
    <rma-icon class="ml-1 transform transition-all" [class.rotate-180]="!collapsed()" glyph="expand_more" size="small" />
  </button>

  <div
    class="flex max-h-full flex-col gap-6 transition-all"
    [ngClass]="{ '!max-h-0 overflow-hidden': collapsed(), 'grid grid-cols-2': isMultiColumn }"
  >
    @for (locationLink of locationLinks; track locationLink) {
      <a
        class="text-xs text-white no-underline hover:text-highlight-blue"
        [routerLink]="isIndividual ? locationLink[verticalType].agentUrl : locationLink[verticalType].agencyUrl"
      >
        {{ locationLink.name }}
      </a>
    }
  </div>
</nav>
